const { createBundleTiles } = require('../../shop/tiles/product-tile-factory');

class OfferGroupTileListController {
    constructor(settings, offerGroupService) {
        this.settings = settings;
        this.offerGroupService = offerGroupService;
    }

    $onInit() {
        this.sortOptions = this.offerGroupService.getSortOptions();
    }

    title() {
        const description = this.offerGroupService.selectedGroup.Description;

        return this.offerGroupService.selectedGroupTotalCount != null
            ? `${description} (${this.offerGroupService.selectedGroupTotalCount})`
            : description;
    }

    createTiles(products) {
        return {
            items: createBundleTiles(products.items),
            totalRecordCount: products.totalRecordCount,
        };
    }

    getTiles(pageSize, pageNumber, sortType = 'Name') {
        return this.offerGroupService.selectOfferGroup(this.offerGroupId)
            .then(() => this.offerGroupService.getProducts({ pageSize, pageNumber, sortType }))
            .then(products => this.createTiles(products));
    }
}

OfferGroupTileListController.$inject = ['Settings', 'OfferGroupService'];

const offerGroupTileListComponentDefinition = {
    bindings: {
        offerGroupId: '<?',
        pageNumber: '<',
        sortBy: '<',
    },
    controller: OfferGroupTileListController,
    template: `
        <wow-tile-list
            list-title="$ctrl.title()"
            page-number="$ctrl.pageNumber"
            sort-by="$ctrl.sortBy"
            sort-options="::$ctrl.sortOptions"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">
        </wow-tile-list>
    `,
};

module.exports = {
    OfferGroupTileListController,
    offerGroupTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/offergroup/offergroup-tile-list.component.js